import { useAuth } from "components/custom/authprovider";
import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import useAutoLogout from "utils/autoLogout";
import { usePackageId } from "utils/functions";
import { SAText } from "utils/functions";

const { CardHeader, CardBody, CardFooter, Card, Col, Row } = require("reactstrap");

function VerifyCard(){
  useAutoLogout();

  const iframeRef = useRef(null);
  const {wt}  = useAuth();
  const history = useHistory();
  const location = useLocation();
  const packageId = usePackageId();


  useEffect(() => {
    const handleIframeMessage = (event) => {
      if (event.origin !== process.env.REACT_APP_PAYMENT_IFRAME) return; //Child
  
      const { type, payload } = event.data;

      if (type === 'FROM_IFRAME') {
        if(payload.action === "SendPhone"){
          sendDataToIframe(wt.p, "SendPhone");
        }
        else if(payload.action === "TransactionError"){
          SAText("Error", payload.data, "error", () => {
            history.push({pathname:"/checkout/" + packageId});
          });
        }
        else if(payload.action === "VerificationError"){
          SAText("Error", payload.data, "error");
        }
        else if(payload.action === "VerificationSuccess"){
          console.log("payload", location.state.paymentdata);
          SAText("Success", "Transaction was successful", "success", () => {
            history.push({
              pathname: "/confirmation",
              state: {paymentdata: location.state.paymentdata, activation: JSON.parse(payload.data)}
            });
          });
        }
      }
    };
  
    window.addEventListener('message', handleIframeMessage);
  
    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, [wt.p]);

  const sendDataToIframe = (data, action) => {
    const message = { type: 'FROM_PARENT', payload: { data: data, action: action } };
    iframeRef.current.contentWindow.postMessage(message, process.env.REACT_APP_PAYMENT_IFRAME); // Child
  };

  return (
    <div className="content">
    <Row>
        <Col md="12">
          <Card>
            <CardHeader className='subTitle'>Your card needs verified before continuing</CardHeader>
              <CardBody>
                <Row>
                  <Col md="12">
                    <p>Your card will be charged one random transactions that is less than $2.00. This transaction will need to be verified below before being able to continue. The  transaction will be returned to your card immediately. Once the card has been verified, your previous transaction will be successfully completed.</p>

                    <p className="bold">Only three verification attempts are accepted before the transaction is reset.</p>
                  </Col>
                </Row>

                <Row>
                  <iframe
                    ref={iframeRef}
                    src={process.env.REACT_APP_PAYMENT_IFRAME + "/" + location.state.paymentFrame + "-verify"} //Child
                    style={{border:0}}
                    width="100%"
                    height="220"
                    title="Card Verification"
                  ></iframe>
                </Row>
              </CardBody>
            <CardFooter>
              
            </CardFooter>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default VerifyCard;
